import type { components } from '../types/api/generated';
import { ffhClient } from '@lib/api/ffh-client';
import { authHeader } from '@lib/api/auth-header';

export type PlayerHistoryResponse =
  components['schemas']['PlayerHistoryResponse'];
export type PlayerHistoryRow = PlayerHistoryResponse['data'][number];

export type GetPlayerHistoryOptions = {
  id: string;
  accessToken?: string;
  limit?: number;
  /**
   * Season year. Defaults to the current season. Player ids are re-minted each
   * season, so the API resolves a current-season id to the matching player in
   * the requested season rather than returning nothing.
   */
  season?: number;
};

export const fetchPlayerHistory = async ({
  id,
  accessToken,
  limit,
  season
}: GetPlayerHistoryOptions): Promise<PlayerHistoryResponse> => {
  const { data, error } = await ffhClient().GET(
    '/league/players/{id}/history',
    {
      params: {
        path: { id },
        query: {
          ...(limit === undefined ? {} : { limit }),
          ...(season === undefined ? {} : { season })
        }
      },
      ...(accessToken ? { headers: authHeader(accessToken) } : {})
    }
  );

  if (error) throw new Error('Failed to load player history');
  return data;
};
